import React, { useState } from 'react';

import { Row, Input, Text } from './styled/SettingsNickNameStyled';

interface LocalizationLike {
    getText: (key: string) => string;
}

interface NickNameProps {
    personalUsername: string;
    localization: LocalizationLike;
    onSave: (value: string) => void;
}

function NickName(props: NickNameProps) {
    const { localization, personalUsername, onSave } = props;

    const [newPersonalUsername, setNewPersonalUsername] = useState(personalUsername);

    return (
        <div>
            <Row>
                <Input
                    type="text"
                    value={newPersonalUsername}
                    onChange={({ target }) => setNewPersonalUsername(target.value)}
                    onBlur={() => {
                        onSave(newPersonalUsername);
                    }}
                    onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => {
                        if (event.key === 'Enter') {
                            event.currentTarget.blur();
                        }
                    }}
                />
            </Row>
            <div style={{ marginTop: 12 }}>
                <Text>{localization.getText('settings.nickname.note')}</Text>
            </div>
        </div>
    );
}

export default NickName;
